import React, { useState } from "react";
import { Users, FileEdit, Send, Settings as SettingsIcon } from "lucide-react";
import Contacts from "./Contacts";
import Templates from "./Templates";
import Campaigns from "./Campaigns";
import Settings from "./Settings";

const TABS = [
  { id: "contacts", label: "Contacts", icon: Users },
  { id: "templates", label: "Templates", icon: FileEdit },
  { id: "campaigns", label: "Campaigns", icon: Send },
  { id: "settings", label: "Settings", icon: SettingsIcon },
];

export default function MailingPage() {
  const [tab, setTab] = useState("campaigns");
  return (
    <div>
      <div className="flex items-center gap-4 mb-8">
        <div className="w-10 h-[1px] bg-[#E8943A]" />
        <span className="velora-micro text-[#7B3F00]">Mailing Server</span>
      </div>

      <div className="flex flex-wrap items-center gap-2 mb-8 border-b border-[#E0D4B6]">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-4 py-3 velora-micro border-b-2 -mb-[1px] transition ${
                active ? "border-[#E8943A] text-[#7B3F00]" : "border-transparent text-[#3D1F00]/50 hover:text-[#3D1F00]"
              }`}
            >
              <Icon size={14}/>
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === "contacts" && <Contacts />}
      {tab === "templates" && <Templates />}
      {tab === "campaigns" && <Campaigns />}
      {tab === "settings" && <Settings />}
    </div>
  );
}
